/*
  Copyright (c) 2020 - present, DITDOT Ltd. - MIT Licence
  https://github.com/ditdot-dev/vue-flow-form
  https://www.ditdot.hr/en
*/

import Vue from "vue";
import Index from "./index.vue";
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";

Vue.use(VuePlyr, {
  plyr: {},
});

new Vue({
  render: (h) => h(Index),
}).$mount("#app");
